import { defineStore } from "pinia";

import modelClass from "@models/site_page";
import * as getters from "@modelStores/helpers/getters-helper";

export const useSitePageStore = defineStore("site_page-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
